<template>
    <Drawer
        :title="title"
        v-model="isBox"
        width="840"
        :mask-closable="false"
        @on-close="FormReset()"
        class-name="drawer-default"
    >
        <div class="set-scroll-form">
            <Row :gutter="32">
                <Col span="24">
                    <DescriptionList class="show-description-title" title="" :col="2"  layout="vertical">
                        <Description term="编号：">
                            {{detail.sn}}
                        </Description>
                        <Description term="采购信息：">
                            {{detail.buyer_title}}
                        </Description>
                        <Description term="项目名称：">
                            {{detail.project_name}}
                        </Description>
                        <Description term="供应商：">
                            {{detail.company}}
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="4"  layout="vertical">
                        <Description term="状态：">
                            <Badge v-if="detail.status === 1" color="blue" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 3" color="orange" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 5" color="green" :text="detail.status_name" />
                            <Badge v-else-if="detail.status === 4 || detail.status === 2" color="red" :text="detail.status_name" />
                            <Badge v-else color="#999999" text="其他" />
                        </Description>
                        <Description term="驳回原因：" v-if="detail.status === 4 || detail.status === 2">
                            {{detail.object_remark}}
                        </Description>
                        <Description term="驳回时间：" v-if="detail.status === 4 || detail.status === 2">
                            {{detail.object_time}}
                        </Description>
                        <Description term="支出类型：">
                            <Tag>{{detail.type_name}}</Tag>
                        </Description>
                        <Description term="申请支出金额：">
                            <Tag color="blue">{{detail.money}}</Tag>
                        </Description>
                        <Description term="支付金额：" v-if="detail.status === 5">
                            <Tag color="green">{{detail.pay_money}}</Tag>
                        </Description>
                        <Description term="支付时间：" v-if="detail.status === 5">
                            {{detail.money}}
                        </Description>
                        <Description term="收款账户：">
                            {{detail.pay_bank_account}}
                        </Description>
                        <Description term="账户实名：">
                            {{detail.pay_bank_real_name}}
                        </Description>
                        <Description term="收款银行：">
                            {{detail.pay_bank_name}}
                        </Description>
                        <Description term="开户地址：">
                            {{detail.pay_bank_address}}
                        </Description>
                        <Description term="申请人：">
                            {{detail.apply_name}}
                        </Description>
                        <Description term="申请时间：">
                            {{detail.apply_time}}
                        </Description>
                        <Description term="审批人：" v-if="detail.status >= 3">
                            {{detail.auditor_name}}
                        </Description>
                        <Description term="审批时间：" v-if="detail.status >= 3">
                            {{detail.auditor_time}}
                        </Description>
                        <Description term="打款人：" v-if="detail.status === 5">
                            {{detail.draw_name}}
                        </Description>
                        <Description term="打款审批时间：" v-if="detail.status === 5">
                            {{detail.draw_time}}
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical">
                        <Description term="采购清单">
                            <div class="uploads">
                                <div class="upload-images" v-for="(item,index) in detail.image" :key="index" @click.stop="">
                                    <img :src="site_url + item">
                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                </div>
                            </div>
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="!!detail.invoice_image && detail.invoice_image.length > 0">
                        <Description term="发票信息">
                            <div class="uploads">
                                <div class="upload-images" v-for="(item,index) in detail.invoice_image" :key="index" @click.stop="">
                                    <img :src="site_url + item">
                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                </div>
                            </div>
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.status === 5">
                        <Description term="支付凭证">
                            <div class="uploads">
                                <div class="upload-images" v-for="(item,index) in detail.pay_image" :key="index" @click.stop="">
                                    <img :src="site_url + item">
                                    <div class="show" @click.stop="PhotoView(site_url + item)">预览</div>
                                </div>
                            </div>
                        </Description>
                    </DescriptionList>
                    <DescriptionList class="show-description-title" title="" :col="1"  layout="vertical" v-if="detail.remark">
                        <Description term="备注信息：">
                            {{detail.remark}}
                        </Description>
                    </DescriptionList>
                </Col>
            </Row>

            <!-- 预览图片 -->
            <Modal
                v-model="is_view_box"
                title="预览"
                :width="840"
                :mask-closable="true"
                :footer-hide="true"
                @on-cancel="PhotoViewClose()">
                <div class="flex-image-box">
                    <img :src="view_url" class="flex-image-box-show">
                </div>
            </Modal>
        </div>
    </Drawer>
</template>

<script>

import {getExpendDetail} from "@/apis/expend";

export default {
    name: 'ExpendShow',
    components: {
    },
    emits: ['trueHandler'],
    data () {
        return {
            title : '支出详情',
            isBox : false,
            detail: [],
            site_url : this.$siteApi,
            is_view_box : false,
            view_url : ''
        }
    },
    methods: {
        /**
         功能：图片预览
         time: 2025-17-15 10:17:00
         **/
        PhotoView(url){
            if(url){
                this.view_url = url;
                this.is_view_box = true;
            }
        },
        /**
         功能：
         time: 2025/12/15 11:16
         **/
        PhotoViewClose(){
            this.is_view_box = false;
            this.view_url = '';
        },

        /**
         功能：
         time: 2025/12/17 16:04
         **/
        GetDetail(expend_id){
            let that = this;
            that.$store.commit('SET_LOADING' , true);
            getExpendDetail(expend_id).then(e => {
                that.detail = e.data;
            })
        },
        /**
         功能：
         time: 2025/12/17 10:47
         **/
        show(expend_id){
            this.isBox = true;
            if(expend_id){
                this.GetDetail(expend_id);
            }
        },
        /**
         功能：
         time: 2025/12/20 11:54
         **/
        FormReset(){
            this.isBox = false;
            this.detail = [];
        }
    }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="less" rel="stylesheet/less">

</style>
